<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import ToggleSwitch from 'primevue/toggleswitch';
import { useDarkModeStore } from '@/stores/darkMode.store';

const darkModeStore = useDarkModeStore();

</script>
<template>
  <div style="display:flex; align-items: center; gap: 0.5rem;">
    <label for="darkModeToggle">Dark Mode <span class="hidden md:inline">(Experimental)</span></label>
    <ToggleSwitch inputId="darkModeToggle" v-model="darkModeStore.isDarkMode" style="--p-toggleswitch-handle-size:1em;--p-toggleswitch-width:2em"/>
  </div>
</template>